import {ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection, isDevMode} from '@angular/core';
import {provideRouter} from '@angular/router';
import {appRoutes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule, provideAnimations} from '@angular/platform-browser/animations';
import {MatPaginatorModule} from '@angular/material/paginator';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import {MatDialogModule} from '@angular/material/dialog';
import {AuthInterceptor} from '@lib-ui/auth/auth.interceptor';
import {MAT_DATE_LOCALE, provideNativeDateAdapter} from '@angular/material/core';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS} from '@angular/material/snack-bar';
import {registerLocaleData} from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import { ServiceWorkerModule } from '@angular/service-worker';
import { OfflineInterceptor } from '@lib-ui/offline/offline.interceptor';

registerLocaleData(localeRu, 'ru');

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(
            BrowserModule, BrowserAnimationsModule, MatPaginatorModule, HttpClientModule, MatDialogModule, AuthInterceptor,
            ServiceWorkerModule.register('ngsw-worker.js', {
                enabled: true,
                // enabled: !isDevMode(),
                // Register the ServiceWorker as soon as the application is stable
                // or after 30 seconds (whichever comes first).
                registrationStrategy: 'registerWhenStable:30000',
            }),),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(appRoutes), provideAnimationsAsync(), provideNativeDateAdapter(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
            useValue: { duration: 3000 },
        },
        {provide: MAT_DATE_LOCALE, useValue: 'ru-RU'},
        { provide: LOCALE_ID, useValue: 'ru' },
        provideAnimations(),
        provideNativeDateAdapter(),
        provideHttpClient(withInterceptors([OfflineInterceptor]))
    ],
};
